@if(mobileQuery.matches) {
<div class="horizontal-sidebar p-y-8 p-x-16 b-b-n bg-white">
  <div class="">
    <div>
      <div class="horizontal-navbar hstack align-items-center flex-wrap">
        @for(item of navItems; track item) {
        <app-horizontal-nav-item [item]="item" class="parentBox {{ item.ddType }}" [ngClass]="{
                pactive: item.route == parentActive ? 'pactive' : ''
              }">
        </app-horizontal-nav-item>
        }

      </div>
    </div>
  </div>
</div>
}
